import { DatePickerProps, DesktopDatePicker } from '@mui/x-date-pickers-pro';
import { useCallback } from 'react';
import BluAsyncDialog from '../AsyncDialog';
import { errorDialogDefaultFunction } from '@bludata/utility-functions';

export const BluDatePicker = ({
  value,
  onChange,
  format = 'DD/MM/YYYY',
  // label,
  'data-testid': dataTestId,
  ...rest
}: DatePickerProps & { 'data-testid'?: string }) => {
  const handleBlur = useCallback(
    async (event: any) => {
      if (value === null || value === undefined) return;
      if (rest.disabled || rest.readOnly) return;

      if (!event.currentTarget.contains(event.relatedTarget)) {
        const elements =
          event.currentTarget.querySelectorAll('[aria-valuetext]');
        let emptyCount = 0;

        for (const el of elements) {
          if (el.getAttribute('aria-valuetext') === 'Vuoto') {
            emptyCount++;
            if (emptyCount > 3) break;
          }
        }

        if (emptyCount === 3) return;

        if (!value) {
          await BluAsyncDialog({
            title: 'Attenzione',
            message: 'Formato della data non valido.',
            type: 'error',
            confimButton: 'Chiudi',
            hideDeclineButton: true,
          });
          return;
        }
        if (!value.isValid()) {
          await BluAsyncDialog({
            title: 'Attenzione',
            message: 'Formato della data non valido.',
            type: 'error',
            confimButton: 'Chiudi',
            hideDeclineButton: true,
          });
        }
      }
    },
    [value],
  );

  return (
    <div data-testid={dataTestId} style={{ display: 'contents' }}>
      <DesktopDatePicker
        format={format}
        value={value}
        onChange={onChange}
      {...rest}
      slotProps={{
        ...rest.slotProps,
        textField: {
          variant: 'standard',
          size: 'small',
          fullWidth: false,
          onBlur: handleBlur,
          ...(rest?.slotProps?.textField as any),
        },
      }}
      onError={(error) => {
        if (error === 'disableFuture') {
          errorDialogDefaultFunction('La data non può essere futura.');
          //@ts-expect-error la funzione non accetta null via ts ma in realità può essere null
          onChange(null);
        }
      }}
    />
    </div>
  );
};
